import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import findResult from '@/utils/resultsHelper';
import selectors from '@/selectors';
import DatasourceService from '../../datasource/service';
import {
  fetchDatasourceFeatures,
  saveDatasourceWizardError,
  saveDatasourceWizardSuccess,
} from '../../datasource/actions';
import { fetchDatasetStatus } from '../../status/actions';
import {
  datasetSettingsChanged,
  refreshDatasetSettings,
  updateActiveDatasetStep,
  updateDatasetProperties,
} from '../../actions';
import DatasetSettingService from '../service';
import actions from '../constants';
import {
  fetchDatasetSettingsError,
  fetchDatasetSettingsSuccess,
  updateDatasetSettingsError,
  updateDatasetSettingsSuccess,
} from '../actions';

export function* updateSettings({
  category,
  code,
  datasetName,
  properties,
}) {
  const { response, error } = yield call(callAdapter, DatasetSettingService.updateSettings(code, properties));

  if (error) {
    yield put(updateDatasetSettingsError(category, code, error, true));
  } else {
    yield put(updateDatasetSettingsSuccess(category, code, response));
    yield put(datasetSettingsChanged(code, datasetName, response));
    yield put(fetchDatasetStatus(code));
  }
}

export function* toggleDatasetSetting({
  category,
  code,
  name,
  datasetName,
}) {
  const items = yield select(selectors.datasetSettings);
  const item = findResult(items, category, code);

  yield updateSettings({
    category, code, datasetName, properties: { [name]: !item[name] },
  });
}

function* afterSwitch(
  category,
  code,
  previousTitle,
  template,
  title,
) {
  yield put(updateActiveDatasetStep(category, code, 2, template));
  if (title !== previousTitle) {
    yield put(updateDatasetProperties(category, code, { catalogue: { title }, steps: { previousTitle } }));
  }
}

function* updateDatasourceSettings(
  category,
  code,
  previousTitle,
  template,
  templateChanged,
  title,
) {
  const items = yield select(selectors.datasourceSettings);
  const item = findResult(items, category, code).copy;
  const { error } = yield call(callAdapter, DatasourceService.updateDatasetDatasource(item));

  if (error) {
    yield put(saveDatasourceWizardError(category, code, error, title, templateChanged));
  } else {
    yield put(saveDatasourceWizardSuccess(category, code, title, templateChanged));
    yield put(fetchDatasourceFeatures('open', code));
    yield afterSwitch(category, code, previousTitle, template, title);
  }
}

export function* switchDatasetType({
  category,
  code,
  previousTitle,
  template,
  title,
  templateChanged,
  datasourceChanged,
}) {
  const { response, error } = templateChanged ? yield call(callAdapter, DatasetSettingService.updateSettings(
    code,
    { catalogue_definition_code: template.code },
  )) : { response: null, error: null };

  if (error) {
    yield put(updateDatasetSettingsError(category, code, error, false));
  } else if (response) {
    yield put(updateDatasetSettingsSuccess(category, code, response));
    yield put(datasetSettingsChanged(code, title, response, datasourceChanged));
  }

  if (!error && datasourceChanged) {
    yield updateDatasourceSettings(category, code, previousTitle, template, templateChanged, title);
  } else if (response) {
    yield afterSwitch(category, code, previousTitle, template, title);
  }
}

export function* settings({ category, code }) {
  const { response, error } = yield call(callAdapter, DatasetSettingService.settings(code));
  if (error) {
    yield put(fetchDatasetSettingsError(category, code, error));
  } else {
    yield put(fetchDatasetSettingsSuccess(category, code, response));
    yield put(refreshDatasetSettings(code, response));
  }
}

export default function* datasetSettingsApi() {
  yield takeEvery(actions.TOGGLE_DATASET_SETTING, toggleDatasetSetting);
  yield takeEvery(actions.SWITCH_DATASET_TYPE, switchDatasetType);
  yield takeEvery(actions.UPDATE_DATASET_SETTINGS, updateSettings);
  yield takeEvery(actions.FETCH_DATASET_SETTINGS, settings);
}
